module.exports = __webpack_public_path__ + "static/media/fig_5.89fe15f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_5.jpg
// module id = 676
// module chunks = 0